import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactToPrint from 'react-to-print';
import Moment from 'react-moment';
import { isArray, isNull } from 'util';
import * as Actions from '../../../actions/Task';
import PlaceHolder from '../../../assets/images/loading.gif';
import Template from '../../../components/Template/AfterLoginTemplate';
import ContractPDFContent from '../../../components/Parts/ContractPDFContent';
import Logo1x from '../../../assets/images/logo.png';
import Logo2x from '../../../assets/images/logo@2x.png';
import Modal from '../../../components/Common/Modal';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    // console.log(this.currentUser);
    this.state = {
      loaded: false,
      bFacilityName: '◯◯◯',
      bAddress: '',
      cUserName: '×××',
      bPic: '',
      workingTime: '',
      workingPlace: '',
      workingResponsiblity: '',
      workingRest: 'なし',
      wages: []
    };
  }

  componentWillReceiveProps = next => {
    const { participantDetail } = this.props.Task;
    if (!this.state.loaded && next.Task.contractLoaded !== this.state.loaded) {
      const cContent = next.Task.contractContent;
      const { task } = next.Task.contractContent;
      const { contract } = next.Task.contractContent;
      // console.log("participantDetail");
      console.log(cContent);
      let approvedDate = participantDetail.approvalDate ? participantDetail.approvalDate : '';
      if (approvedDate !== '') {
        const date = new Date(Number(approvedDate));
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        approvedDate = `${year}/${month}/${day} ${hour}:${minute}`;
      }
      const cName =
        participantDetail.lastName + participantDetail.fastName
          ? participantDetail.lastName + participantDetail.fastName
          : '×××';
      const cAddress =
        participantDetail.prefecture + participantDetail.municipality + participantDetail.street
          ? participantDetail.prefecture + participantDetail.municipality + participantDetail.street
          : '';
      // ja-jp
      let bPic = `${this.currentUser.picTitle}    ${this.currentUser.picName} `;

      console.log(bPic);
      let { workingRest } = this.state;
      let { titleWages } = this.state;
      let { workingTime } = this.state;
      let workingPlace =
        task.task_postalCode +
        ' ' +
        task.task_prefecture +
        ' ' +
        task.task_city +
        ' ' +
        task.task_block +
        ' ' +
        task.task_street;
      let { workingResponsiblity } = this.state;
      let { wages } = this.state;
      if (!isNull(task)) {
        wages = [task.fee];
        workingTime = `${task.startDate}     ${task.workingHours}`;
        workingResponsiblity = task.title;
        let workingCategory = '';
        const category = task.taskCategoryDetail;
        if (isArray(category)) {
          category.forEach(element => {
            workingCategory += element.value;
          });
        }
        workingResponsiblity += `\n${workingCategory}`;
      }

      if (!isNull(contract)) {
        if (contract.workingPlace !== '') {
          workingPlace = contract.workingPlace ? contract.workingPlace : workingPlace;
        }
        workingTime = contract.workingTime ? contract.workingTime : workingTime;
        workingResponsiblity = contract.workingResponsiblity
          ? contract.workingResponsiblity
          : workingResponsiblity;
        wages = contract.wages;
        titleWages = contract.titleWages ? contract.titleWages : titleWages;
        bPic = contract.bPic ? contract.bPic : bPic;
        workingRest = contract.workingRest ? contract.workingRest : workingRest;
      }
      const bAddress = `${this.currentUser.postalCode} ${this.currentUser.prefecture} ${this.currentUser.municipality} ${this.currentUser.locDescription} ${this.currentUser.street}`;
      this.setState({
        bFacilityName: this.currentUser.enterpriseName,
        cUserName: cName,
        bAddress,
        loaded: true,
        bPic,
        workingTime,
        workingPlace,
        workingResponsiblity,
        wages,
        titleWages,
        workingRest
      });
      // console.log(this.state);
    }
  };

  componentWillUnmount = () => {
    this.props.resetContractContent();
  };

  //  eslint-disable-next-line react/no-deprecated
  componentWillMount = () => {
    const wages = [''];
    const titleWages = ['報酬'];
    this.setState({ wages, titleWages });
    this._loadConstractContent();
  };

  _loadConstractContent = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.taskid;
    const taskrewId = this.props.match.params.taskrews_id;
    this.props.getTaskContractContent(enterpriseId, token, taskId, taskrewId);
  };

  _saveTaskContractContent = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.taskid;
    const taskrewId = this.props.match.params.taskrews_id;
    const { workingTime } = this.state;
    const { workingPlace } = this.state;
    const { workingResponsiblity } = this.state;
    const { wages } = this.state;
    const { titleWages } = this.state;
    const { bPic } = this.state;
    const { workingRest } = this.state;

    const datas = {
      workingTime,
      workingPlace,
      workingResponsiblity,
      wages,
      titleWages,
      bPic,
      workingRest
    };
    this.props.saveTaskContractContent(token, enterpriseId, taskId, taskrewId, datas);
  };

  goBack = () => {
    // console.log(this.props);
    this.props.history.goBack();
  };

  _setValue = e => {
    const { name } = e.target;
    const { value } = e.target;
    this.setState({ [name]: value });
  };

  _addWages = () => {
    const { wages } = this.state;
    const { titleWages } = this.state;
    wages.push('');
    if (titleWages.length < 1) {
      titleWages.push('賃金');
    } else {
      titleWages.push('その他');
    }
    this.setState({ wages, titleWages });
  };

  _removeWages = () => {
    const { wages } = this.state;
    const { titleWages } = this.state;
    if (wages.length > 1) {
      wages.splice(-1, 1);
      titleWages.splice(-1, 1);
      this.setState({ wages, titleWages });
    }
  };

  _changeWages = e => {
    const did = e.target.attributes.did.value;
    let { value } = e.target;
    if (did === '0') {
      value = value.replace(/\D/g, '');
      value += ' 円(諸経費込み)';
    }
    console.log(value);
    const { wages } = this.state;
    if (wages.length > 0) {
      wages[did] = value;
      this.setState({ wages });
    }
  };

  _renderWages = () => {
    return this.state.wages.map((key, index) => {
      const wageAmnt = key.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円';
      return (
        <tr>
          <td className="subtitle center">{this.state.titleWages[index]}</td>
          <td>
            <textarea
              className="f_width"
              onChange={this._changeWages}
              did={index}
              value={wageAmnt}
            />
          </td>
        </tr>
      );
    });
  };

  render = () => {
    return (
      <Template>
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle={this.props.App.modalHeader}
          // eslint-disable-next-line no-console
          okClickHandler={() => this.props.modalCloseInTask()}
          okText="閉じる"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.modalText}
        </Modal>
        <div>
          <div className="contract_layout">
            <div className="div_print">
              <ContractPDFContent
                ref={el => (this.componentRef = el)}
                userData={this.props.Task.participantDetail}
                taskData={this.props.Task.taskDetail}
                passData={this.state}
              />
            </div>
            <div className="contract">
              <div className="part1">
                <img src={Logo1x} srcSet={`${Logo1x} 1x,${Logo2x} 2x`} alt="" className="logo" />
                <div className="time p_tb_10 right">
                  {' '}
                  <Moment tz="Asia/Tokyo" format="YYYY年MM月DD日" style={{ marginRight: '10px' }} />
                </div>
                <div className="title p_tb_10 center">業務委託契約書</div>
                <div className="row">
                  <div className="box col-12">
                    <div className="b_name">
                      <span className="bb">
                        <span className="value">{this.state.cUserName}</span>
                        <span>殿</span>
                      </span>
                    </div>
                    <div className="row mt-10">
                      <div className="col-4" />
                      <div className="col-3 right subtitle">事業主の氏名又は名称</div>
                      <div className="col-5">{this.state.bFacilityName}</div>
                    </div>
                    <div className="row mt-10">
                      <div className="col-4" />
                      <div className="col-3 right subtitle">所在地</div>
                      <div className="col-5">{this.state.bAddress}</div>
                    </div>
                    <div className="row mt-10">
                      <div className="col-4" />
                      <div className="col-3 right subtitle">代表者氏名</div>
                      <div className="col-5">
                        <input
                          className="f_width bpic"
                          name="bPic"
                          onChange={this._setValue}
                          value={this.state.bPic}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="name-block">
                    <h3>次のとおり業務委託契約を締結します。</h3>
                  </div>
                  <table>
                    <tbody>
                      <tr>
                        <td className="subtitle center">契約期間</td>
                        <td>
                          <textarea
                            className="f_width"
                            name="workingTime"
                            onChange={this._setValue}
                            value={this.state.workingTime}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="subtitle center">実施場所</td>
                        <td>
                          <textarea
                            className="f_width"
                            name="workingPlace"
                            onChange={this._setValue}
                            value={this.state.workingPlace}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="subtitle center">
                          <p>業務内容</p>
                        </td>
                        <td>
                          <textarea
                            className="f_width"
                            name="workingResponsiblity"
                            onChange={this._setValue}
                            value={this.state.workingResponsiblity}
                          />
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="subtitle center">休暇</td>
                        <td>
                          <textarea
                            className="f_width"
                            name="workingRest"
                            onChange={this._setValue}
                            value={this.state.workingRest}
                          />
                        </td>
                      </tr> */}
                      {this._renderWages()}
                    </tbody>
                  </table>
                </div>
                <div className="div_btn">
                  <button type="button" className="btn-plus" onClick={this._addWages}>
                    <i class="fas fa-plus-circle"></i>
                  </button>
                  <button type="button" className="btn-minus" onClick={this._removeWages}>
                    <i class="fas fa-minus-circle"></i>
                  </button>
                </div>
                <div className="div_bottom">
                  <div className="row">
                    <div className="caution">※　以上のほかは、当社就業規則による。</div>
                  </div>
                </div>
                <div className="message">
                  <p>
                    以上の契約の成立を証するため、本契約書を2通作成し、各自記名押印の上、
                    <br />
                    甲乙各1通ずつあこれを保有するものとする。
                  </p>
                </div>
                <div className="contracted-date">
                  <ul>
                    <li>令和</li>
                    <li>年</li>
                    <li>月</li>
                    <li>日</li>
                  </ul>
                </div>
                <div className="signature-seal">
                  <ul>
                    <li>
                      <h3>甲</h3>
                      <h4></h4>
                      <h5>印</h5>
                    </li>
                    <li>
                      <h3>乙</h3>
                      <h4></h4>
                      <h5>印</h5>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-4 center">
                <button
                  type="button"
                  onClick={this._saveTaskContractContent}
                  className="btn btn-primary "
                  style={{
                    marginBottom: '10mm'
                  }}
                >
                  保存する
                </button>
              </div>
              <div className="col-4 center">
                <button
                  type="button"
                  className="btn btn-primary "
                  style={{
                    marginBottom: '10mm'
                  }}
                >
                  <ReactToPrint
                    trigger={() => <a href="#">出力する </a>}
                    content={() => this.componentRef}
                  />
                </button>
              </div>
              <div className="col-4 center">
                <button
                  type="button"
                  onClick={this.goBack}
                  className="btn btn-primary "
                  style={{
                    marginBottom: '10mm'
                  }}
                >
                  戻る
                </button>
              </div>
            </div>
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
